export type SubscriptionInterval = 'month' | 'year'

export enum PaymentStatus {
  Canceled = 'canceling',
  Completed = 'completed',
  Incomplete = 'incomplete',
  Active = 'active',
}

export enum OrderType {
  OneTime = 'One Time',
  Subscription = 'Subscription Renewal',
}

export interface Subscription {
  CanceledAt: string | null
  created: string
  currency: string
  end: string
  id: string
  interval: SubscriptionInterval
  name: string
  offerSnapshot: string
  price: number
  project: { slug: string; title: string }
  status: PaymentStatus
  platformSubscriptionId: string
}

export interface Order {
  created: string
  currency: string
  id: number
  project: {
    slug: string
    title: string
  }
  price: number
  paidPrice: number
  status: PaymentStatus
  subscriptionrecordSet: [{ id: number }] | []
}

export interface OrdersAndSubscriptions {
  orders: Order[]
  marketSubscriptions: Subscription[]
}

export interface Perk {
  id: string
  name: string
  product: {
    active: boolean
    name: string
    id: string
  }
}
